import { makeStyles } from 'tss-react/mui';
import { BrandColors } from './../../constants/brandColors';
import { Theme } from '@mui/material';

export type AuthPageStyleProps = {
  isICPEnabled: boolean;
};

export const AuthPageStyles = makeStyles<AuthPageStyleProps>()((theme: Theme, props) => ({
  container: {
    marginLeft: 'auto',
    marginRight: 'auto',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '54rem',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '71.25rem',
    },
  },
  grid: {
    [theme.breakpoints.up('lg')]: {
      padding: '2rem 0',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '5rem 0',
    },
  },
  paper: {
    padding: '2rem 1.5rem 2.5rem 1.5rem',

    // ICP
    [theme.breakpoints.down('md')]: {
      paddingBottom: props.isICPEnabled ? '4rem' : '',
    },

    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem 1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: '2.5rem 5rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '2rem',
    },
  },
  forgotPasswordPaper: {
    padding: '2rem 1.5rem 2.5rem 1.5rem',
    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem 1.5rem',
    },
    [theme.breakpoints.up('md')]: {
      padding: '2.5rem 5rem 5rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: '2rem',
    },
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '25%',
    left: '40%',
  },
  progressMeterAlert: {
    marginTop: '0.5rem',
  },
  passwordContainer: {
    caretColor: 'black',
    fontFamily: 'monospace',
    fontSize: '1rem',
    position: 'relative',
    overflow: 'hidden',
    '& input': {
      color: 'transparent',
      fontFamily: 'monospace',
      '@media screen and (-ms-high-contrast: none)': {
        paddingRight: '0rem',
      },
    },
    '& input::placeholder': {
      fontFamily: "'Open Sans', sans-serif",
    },
    '& :-ms-input-placeholder': {
      fontFamily: "'Open Sans', sans-serif",
    },
    '& input::selection': {
      color: 'transparent',
      background: BrandColors.selectionColor,
    },
    '&:after': {
      position: 'absolute',
      top: '.75rem',
      left: '1.1875rem',
      pointerEvents: 'none',
      width: 'calc(100% - 2.5rem)',
      overflow: 'hidden',
    },
  },
  padding12: {
    '& p, h2': {
      padding: '0.75rem',
    },
  },
  alignCenter: {
    textAlign: 'center',
  },
  resetPassword: {
    marginTop: '0 !important',
    paddingRight: '0 !important',
    marginBottom: '1rem',
    [theme.breakpoints.up('lg')]: {
      minHeight: 'calc(100vh - 21.563rem)',
    },
  },
  signInTab: {
    '& .MuiTabs-indicator': {
      left: '6.625rem !important',
    },
  },
  passwordStengthMeter: {
    maxWidth: 'unset',
  },
}));
